import { createIcon } from '../icon'
import MultiPacksIcon from '@/components/atoms/svg/Multipacks'

export const MultiPacksIconDefault = createIcon(MultiPacksIcon)
